import React from "react";
import {
  FaHome,
  FaTimes,
  FaShieldAlt,
  FaCheckCircle,
  FaStar,
  FaLock,
  FaArrowRight,
  FaInfoCircle,
} from "react-icons/fa";
import "../../../assets/css/sellers/dashboard/kycmodal/kycmodel.css";

/**
 * Seller First-Login KYC Verification Modal.
 *
 * UI/UX design only — no API calls or KYC form logic yet, per brief.
 * The parent (Seller Dashboard) controls visibility and wires up the
 * two callbacks once the KYC flow is implemented.
 *
 * Props:
 *  - isOpen         : bool     -> controls visibility
 *  - onCompleteKyc  : fn()     -> "Complete KYC First" click (route to KYC flow later)
 *  - onSkip         : fn()     -> "Skip for Now" click / close icon click
 */
function KYCModel({ isOpen, onCompleteKyc, onSkip }) {
  if (!isOpen) return null;

  return (
    <div className="kyc-overlay" role="dialog" aria-modal="true" aria-labelledby="kyc-heading">
      <div className="kyc-modal">
        <button
          type="button"
          className="kyc-close-btn"
          onClick={onSkip}
          aria-label="Close and skip for now"
        >
          <FaTimes size={15} />
        </button>

        {/* ================= LEFT PANEL ================= */}
        <div className="kyc-left">
          <div className="kyc-left-brand">
            <div className="kyc-left-logo">
              <FaHome />
            </div>
            <div>
              <p className="kyc-left-brand-text">Estate Experts</p>
              <p className="kyc-left-brand-tagline">Find Your Dream Property</p>
            </div>
          </div>

          <h2 className="kyc-left-heading">
            Build Trust.
            <br />
            <span className="kyc-left-heading-accent">Grow Your Business.</span>
          </h2>

          <p className="kyc-left-text">
            Complete your KYC to get full access to all seller features and
            start listing your properties with confidence.
          </p>

          <div className="kyc-left-image-wrap">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZZzXmtHDvrpG5V28qnmGJV3g1-WDEKzVz9zqHHpXfcZl0mcH40S6mmBE&s=10" 
            alt="Estate Experts Property" className="kyc-left-image" />
            <div className="kyc-left-floating-card">
              <div className="kyc-left-floating-icon">
                <FaCheckCircle />
              </div>
              <div>
                <p className="kyc-left-floating-title">Verified Sellers</p>
                <p className="kyc-left-floating-text">
                  Build more credibility and attract serious buyers.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ================= RIGHT PANEL ================= */}
        <div className="kyc-right">
          <div className="kyc-shield-icon">
            <FaShieldAlt />
          </div>

          <h1 className="kyc-heading" id="kyc-heading">
            Complete Your KYC Verification
          </h1>

          <p className="kyc-subtext">
            To start using all seller features, please complete your KYC
            verification. This helps us keep the platform safe and
            trustworthy for everyone.
          </p>

          {/* ── Benefits ── */}
          <div className="kyc-benefits">
            <div className="kyc-benefit">
              <div className="kyc-benefit-icon">
                <FaShieldAlt />
              </div>
              <p className="kyc-benefit-title">Build Trust</p>
              <p className="kyc-benefit-text">Increase buyer confidence</p>
            </div>
            <div className="kyc-benefit">
              <div className="kyc-benefit-icon">
                <FaStar />
              </div>
              <p className="kyc-benefit-title">Unlock Features</p>
              <p className="kyc-benefit-text">List &amp; publish properties</p>
            </div>
            <div className="kyc-benefit">
              <div className="kyc-benefit-icon">
                <FaLock />
              </div>
              <p className="kyc-benefit-title">Stay Verified</p>
              <p className="kyc-benefit-text">Meet platform requirements</p>
            </div>
          </div>

          {/* ── CTAs ── */}
          <div className="kyc-cta-group">
            <button type="button" className="kyc-btn-primary" onClick={onCompleteKyc}>
              <span>Complete KYC First</span>
              <FaArrowRight />
            </button>
            <button type="button" className="kyc-btn-secondary" onClick={onSkip}>
              Skip for Now
            </button>
          </div>

          <p className="kyc-footer-note">
            <FaInfoCircle /> You can also complete your KYC later from your
            profile settings.
          </p>
        </div>
      </div>
    </div>
  );
}

export default KYCModel;